import Quill from 'quill';
import '../../../../../../../../../../utils/string/string-prototype.utils.ts';

const BlockEmbed: {
  new(domNode, value);
  value(domNode);
  create(value);
} = Quill.import('blots/block/embed');

/**
 * Quill/Parchment Blot to allow block shortcode placeholders
 * @class BlockShortcodeBlot
 * @extends BlockEmbed
 */
export class BlockShortcodeBlot extends BlockEmbed {
  /** @inheritdoc */
  static blotName: string = 'blockShortcode';

  /** @inheritdoc */
  static tagName: string = 'DIV';

  /** @inheritdoc */
  static create(value: HTMLElement) {
    if (this.isShortcode(value)) {
      value.contentEditable = 'false';
      return value;
    }
    super.create(value);
  }

  /** @inheritdoc */
  static value(domNode) {
    if (this.isShortcode(domNode)) {
      return domNode;
    }
    super.value(domNode);
  }

  /** @inheritdoc */
  static formats(domNode) {
    const formats = {};
    return formats;
  }

  static isShortcode(domNode) {
    return domNode.dataset && domNode.dataset.shortcode;
  }

  /**
   * Key value pair of the donNode's dataset
   */
  data: DOMStringMap;

  /**
   * The model tag that gets passed in
   */
  modelTag: HTMLElement;

  constructor(public domNode: any, value?: any) {
    super(domNode, value);
    if (BlockShortcodeBlot.isShortcode(domNode)) {
      this.data = domNode.dataset;
      this.modelTag = domNode;
    }
  }

  setDataAttributes(domNode, dataset?: DOMStringMap): void {
    const data = {...this.data, ...dataset};
    Object.keys(data).forEach((key) => {
      domNode.setAttribute(`data-${key}`.camelToHyphen(), data[key]);
    });
  }

  getModelTag(domNode): HTMLElement {
    return this.modelTag;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/shortcode/block/block.shortcodes.blot.ts